import { EmploymentType, MaximumBudget } from "@justhome/common/api/core";

export enum YesNo {
  yes = "YES",
  no = "NO",
}

export enum BudgetCheckStepName {
  consent,
  federalState,
  employmentType,
  employedIncome,
  selfEmployedIncome,
  retiredIncome,
  equity,
  contact,
  result,
}

export interface BudgetCheckFormValues {
  federalState: MaximumBudget["federalState"];
  employmentType: EmploymentType;
  employmentStart?: string;
  monthlyNetIncome?: number;
  equity: number;
  existingDebt?: number;
  yearlyNetIncome?: number;
  wantsToSellAProperty?: YesNo;
  hasSpecificProperty?: YesNo;
}
